import styled from "styled-components";

const Component = styled.div``;

export default function CarouselAutoMove() {
  return <Component></Component>;
}
